<template>
  <el-row class="form-item">
    <el-col :span="3"><span class="required-text">*</span>选择工厂</el-col>
    <el-col :span="21">
      <el-input placeholder="请填写工厂Code" class="input-prepend" v-model="payload.entityCode" @input="InputEntity" >
        <i slot="suffix" v-if="entityVer.show && entityVer.success" class="el-input__icon el-icon-success" style="color: #21BA45"></i>
        <i slot="suffix" v-if="entityVer.show && !entityVer.success" class="el-input__icon el-icon-error" style="color: #C8102D"></i>
      </el-input>
      <el-button class="btn-blue" size="small" style="margin-left: 15px" @click="getEntityInfo">验证</el-button>
      <span class="entity-name" v-if="entityVer.show && entityVer.success">{{ entityName }}</span>
    </el-col>
    <el-col :span="3"><span class="required-text">*</span>选择成本中心</el-col>
    <el-col :span="21">
      <el-input placeholder="请填写成本中心Code" class="input-prepend" v-model="payload.costCenterCode" @input="InputCost" >
        <i slot="suffix" v-if="costVer.show && costVer.success" class="el-input__icon el-icon-success" style="color: #21BA45"></i>
        <i slot="suffix" v-if="costVer.show && !costVer.success" class="el-input__icon el-icon-error" style="color: #C8102D"></i>
      </el-input>
      <el-button class="btn-blue" size="small" style="margin-left: 15px" @click="getCostInfo">验证</el-button>
    </el-col>
    <!-- <el-col :span="3"><span class="required-text">*</span>选择采购组织</el-col>
    <el-col :span="21">
      <el-select v-model="payload.purchaseOrg" placeholder="选择采购组织" class="org-select" clearable size="small" @change="setValue">
        <el-option
          v-for="item in orgList"
          :key="item.value"
          :label="item.value"
          :value="item.key">
        </el-option>
      </el-select>
    </el-col> -->
  </el-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'item-order-entity-picker',
  data () {
    return {
      payload: {
        entityId: '',
        entityCode: '',
        costCenterCode: '',
        costCenterId: ''
        // purchaseOrg: 'CNY3'
      },
      entityVer: {
        show: false,
        success: false
      },
      costVer: {
        show: false,
        success: false
      },
      entityName: '',
      costCenterName: ''
    }
  },
  computed: {
    ...mapState({
      // orgList: state => state.base.purchaseOrgMap
    })
  },
  created () {
    this.$store.dispatch('getDictByName', 'purchaseOrgMap')
  },
  methods: {
    // 验证实体信息
    getEntityInfo () {
      if (!this.payload.entityCode) {
        this.payload.entityCode = ''
        this.setValue()
        this.$message.error('请输入工厂Code并验证')
        return
      }
      this.$store.dispatch('verifEntity', this.payload.entityCode).then(res => {
        if (res.data.resultCode === '0') {
          this.entityVer.show = true
          if (!res.data.resultData.companyEntityDTO) {
            this.$message.error('无此工厂')
            // this.payload.entityCode = ''
            this.entityVer.success = false
          } else {
            this.entityVer.success = true
            this.payload.entityId = res.data.resultData.companyEntityDTO.entityId
            this.entityName = res.data.resultData.companyEntityDTO.entityName
          }
          this.setValue()
        }
      })
    },
    // 验证成本中心
    getCostInfo () {
      if (!this.payload.entityId) {
        this.$message.error('请输入工厂code并验证')
        return
      }
      if (!this.payload.costCenterCode) {
        this.payload.costCenterId = ''
        this.setValue()
        this.$message.error('请输入成本中心编码')
        return
      }
      let params = {
        costCenterCode: this.payload.costCenterCode,
        entityId: this.payload.entityId
      }
      this.$store.dispatch('getCostInfo', params).then(res => {
        if (res.data.resultCode === '0') {
          this.costVer.show = true
          if (!res.data.resultData.baseCostCenter) {
            this.$message.error('无此成本中心')
            this.payload.costCenterId = ''
            this.costVer.success = false
          } else {
            this.costVer.success = true
            this.payload.costCenterId = res.data.resultData.baseCostCenter.costCenterId
          }
          this.setValue()
        }
      })
    },
    InputEntity () {
      this.entityVer.show = false
    },
    InputCost () {
      this.costVer.show = false
    },
    setValue () {
      this.$emit('setValue', this.payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  padding: 20px 0;
  line-height: 55px;
  .el-col-21 {
    height: 100%;
    display: flex;
    align-items: center;
    .el-input {
      width: 260px;
    }
    .el-select {
      vertical-align: middle;
      margin-right: $content-large;
      width: 260px;
    }
  }
  .input-round {
    margin-right: 10px;
  }
}

.entity-name {
  padding-left: $content-large;
  line-height: 30px;
}
</style>
